import { type ProductPrice } from 'ecosystem'

export const getProductOriginalPrice = (product: ProductPrice): number => {
  return product.originalPrice ?? 0
}

export const getProductPrice = (product: ProductPrice): number => {
  return product.price ?? getProductOriginalPrice(product)
}
